import "video-react/dist/video-react.css";

import { ControlBar, FullscreenToggle, Player } from "video-react";

import React from "react";

const VideoPlayer = ({ onStart, onEnd, src }) => {
  // Funkcija koja se poziva kada video počne
  const handleStart = () => {
    if (onStart) onStart(); // Poziva onStart, ako je prosleđena
  };

  // Funkcija koja se poziva kada video završi
  const handleEnd = () => {
    if (onEnd) onEnd(); // Poziva onEnd, ako je prosleđena
  };

  return (
    <Player
      src={src}
      autoPlay
      playsInline
      onPlay={handleStart} // Pozivanje handleStart pri pokretanju videa
      onEnded={handleEnd} // Pozivanje handleEnd kada video završi
    >
      <ControlBar disableDefaultControls={true}>
        <FullscreenToggle />
      </ControlBar>
    </Player>
  );
};

export default VideoPlayer;
